// eslint-disable-next-line eag/match-named-export
import {i18n} from '@online-offer/i18n';

export const getHourTranslation = (value: number) =>
  value === 1 ? i18n.t('general.labels.hour') : i18n.t('general.labels.hours');

export const getMinuteTranslation = (value: number) =>
  value === 1 ? i18n.t('general.labels.minute') : i18n.t('general.labels.minutes');
